import React from "react";

const Legal = () => {
  return (
    <div className="legal-container">
      <h1>Rechtliche Hinweise</h1>

      <section>
        <h2>Haftungsausschluss</h2>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
            Durch die Nutzung dieser Website stimmen Sie zu, dass nichts auf der Website als medizinischer Rat, Diagnose oder Behandlung betrachtet oder verwendet werden sollte.
        </p>
        <p>
            Zusätzlich erkennen Sie an, dass einige der auf dieser Seite genannten oder demonstrierten Aktivitäten bestimmte 
            Risiken beinhalten, einschließlich, aber nicht beschränkt auf Herzinfarkt, Schlaganfall, Verletzungen 
            von Knochen, Gelenken oder Muskeln, ernsthafte Wirbelsäulen- und Nackenverletzungen, die zu vollständiger 
            oder teilweiser Lähmung führen können. Sie führen freiwillig die genannten Aktivitäten aus, 
            vollständig bewusst über die damit verbundenen Gefahren, und stimmen hiermit zu, jegliche und alle 
            inhärenten Risiken von Verletzungen, Sachschäden oder Tod zu akzeptieren.
        </p>
        <p>
            Keine Haftung für Verletzungen, die durch die Nutzung der Website entstehen, 
            und Sie stimmen zu, dass diese Website, seine Eigentümer und Mitarbeiter nicht verantwortlich sind 
            für jeglichen Verlust von Eigentum, Verletzungen oder Tod, die im Zusammenhang mit Ihrer Nutzung der 
            Dienste dieser Website stehen. 
            Abschließend stimmen Sie zu, dass MuscleWiki, seine Eigentümer oder Mitarbeiter Ihnen gegenüber unter 
            keiner Auslegung von Gesetzen, Haftung oder Schadensersatz im Zusammenhang mit Ihrer Nutzung der Dienste 
            oder Produkte dieser Website haftbar sind.
        </p>
      </section>

      <section>
        <h2>Datenschutz</h2>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. 
          Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG). 
          In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.
        </p>
        <p>
        Datenverarbeitung auf dieser Internetseite
Es werden automatisch Informationen in den Server Log Files gespeichert. Informationen, die Ihr Browser an uns übermittelt. Dies sind:

Browsertyp/ -version
verwendetes Betriebssystem
Referrer URL (die zuvor besuchte Seite)
Hostname des zugreifenden Rechners (IP Adresse)
Uhrzeit der Serveranfrage.
Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen und eine Auswertung dieser Daten die über eine statistische Auswertung hinausgeht findet nicht statt. Die Daten werden zudem nach einer statistischen Auswertung gelöscht.
Löschung der gespeicherten Daten.
Die Löschung der gespeicherten personenbezogenen Daten erfolgt, wenn Sie Ihre Einwilligung zur Speicherung widerrufen, wenn ihre Kenntnis zur Erfüllung des mit der Speicherung verfolgten Zwecks nicht mehr erforderlich ist oder wenn ihre Speicherung aus sonstigen gesetzlichen Gründen unzulässig ist.
        </p>
        <p>
        Auskunft über gespeicherte Daten.
        Auf Wunsch erhalten Sie unentgeltlich Auskunft über alle personenbezogenen Daten, die über Sie gespeichert sind. Selbstverständlich haben Sie die Möglichkeit, etwaige Fehler zu berichtigen, zeitlich überholte Informationen auf den neuesten Stand zu bringen oder die gespeicherten Daten löschen zu lassen. Darüber hinaus können Sie eine bereits erteilte Einwilligung zur Erhebung, Verarbeitung und Nutzung Ihrer personenbezogenen Daten jederzeit widerrufen.  
        </p>
        <p>
        Kontaktaufnahme:
        Wenn Sie Fragen, Kommentaren, Anregungen oder Beschwerden an mich haben und mich über info@e-si.de kontaktieren, geben Sie damit Ihr Einverständnis, dass ich Sie zum Zwecke der Beantwortung per E-Mail kontaktieren darf. Die von Ihnen bei der Kontaktaufnahme übermittelten persönlichen Daten,wie E-Mail-Adresse und ggf. weitere Angaben (Name etc.), werden nur für die Beantwortung genutzt und nicht an Dritte weitergegeben.
        </p>
        <p>
        Änderung dieser Datenschutzbestimmungen
        Ich behalte mir das Recht vor, diese Sicherheits- und Datenschutzmaßnahmen zu verändern, soweit dies wegen der technischen Entwicklung erforderlich wird. In diesen Fällen werden auch diese Hinweise zum Datenschutz entsprechend angepasst. Bitte beachten Sie daher die jeweils aktuelle Version der Datenschutzerklärung.
        </p>
        <p>
        Kinder
Personen unter 18 Jahren sollten ohne Zustimmung der Eltern oder Erziehungsberechtigten keine personenbezogenen Daten übermitteln. Es werden keine personenbezogenen Daten von Kindern und Jugendlichen angefordert, gesammelt und diese werden nicht an Dritte weitergegeben.
        </p>
        <p>
        Cookies
        Die Internetseiten verwenden an mehreren Stellen so genannte Cookies. Sie dienen dazu, das Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert. Die meisten der verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
        </p>
      </section>

      <section>
        <h2>Impressum</h2>
        <p>
          Anbieter dieser Website:<br />
          Ingo Eyring<br />
          Landshuter Str. 5<br />
          94431 Pilsting<br />
          Deutschland<br />
          E-Mail: info@e-si.de<br />
          Telefon: 09953 489029
        </p>
      </section>
    </div>
  );
};

export default Legal;